import { appInsights } from "./appInsights";
import { clearPendingScreenNavigation, getPendingScreenNavigation } from "./navigationTiming";
import { APP_KPI_NAME } from "./utils";

export function completeScreenNavigation(expectedToScreen?: string) {
  const pending = getPendingScreenNavigation();

  if (!pending) return;

  if (expectedToScreen && pending.toScreen !== expectedToScreen) {
    return;
  }

  const durationMs = performance.now() - pending.startedAt;
  appInsights.trackMetric({
    name: APP_KPI_NAME.PCS_SCREEN_NAVIGATION,
    average: durationMs,
    sampleCount: 1,
    properties: {
      module: pending.module,
      fromScreen: pending.fromScreen,
      toScreen: pending.toScreen,
    } as never,
  });

  appInsights.trackEvent({
    name: `${APP_KPI_NAME.PCS_SCREEN_NAVIGATION}_completed`,
    properties: {
      module: pending.module,
      fromScreen: pending.fromScreen,
      toScreen: pending.toScreen,
      durationMs,
    },
  });

  clearPendingScreenNavigation();
}
